import { render, staticRenderFns } from "./ClientOrderDetailsPrint2PDF.vue?vue&type=template&id=633f8a78&"
import script from "./ClientOrderDetailsPrint2PDF.vue?vue&type=script&lang=js&"
export * from "./ClientOrderDetailsPrint2PDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports